import Featurebase, {
  configure,
  initFeedback,
  destroyFeedback,
  clearConfig,
  shutdown
} from 'featurebase-js';
import { defineNuxtPlugin } from '~/.nuxt/imports';

let initialized = false;

export default defineNuxtPlugin((nuxtApp) => {
  const { provide } = nuxtApp;

  const initFeaturebase = async () => {
    if (initialized) {
      return;
    }

    try {
      // Read lazily: this plugin runs before plugins/axios.ts injects $sdk
      const { $sdk, $config } = nuxtApp;
      const { token } = await $sdk.account.createFeaturebaseToken();

      Featurebase({
        appId: $config.featurebaseAppId,
        messenger: true
      });

      configure({
        featurebaseJwt: token
      });

      // Initialize the feedback widget
      initFeedback({
        theme: 'light',
        placement: 'right'
      });

      initialized = true;
    } catch (err) {
      console.error('Featurebase init failed:', err);
    }
  };

  const resetFeaturebase = () => {
    try {
      destroyFeedback();
      clearConfig();
      shutdown();
    } catch (err) {
      console.warn('Featurebase cleanup failed:', err);
    } finally {
      initialized = false;
    }
  };

  provide('featurebase', initFeaturebase);
  provide('featurebaseReset', resetFeaturebase);
});
